import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatFilterBar = createCustomElementWrapper('kat-filter-bar', 'KatFilterBar', {
    'katFilterBarAction': 'KatFilterBarAction',
    'showActionApply': 'show-action-apply',
    'showActionClear': 'show-action-clear',
    'showActionFilters': 'show-action-filters',
    'showActionSearch': 'show-action-search',
    'showActionSettings': 'show-action-settings',
    'showActionSort': 'show-action-sort',
}, {
    'onAction': 'action',
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/filter-bar.js
// module id = 1216
// module chunks = 0